module.exports = __webpack_public_path__ + "img/组 126@2x(8).0d217451.png";